export default __webpack_public_path__ + "static/media/logo.476fc945.svg";